// ============================================================================
// INDUSTRIES — each page has genuinely tailored content (not just a name swap)
// ============================================================================

export const industries = [
  {
    slug: "electricians",
    name: "Electricians",
    image:
      "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBob21lfGVufDB8fHx8MTc4NTgyMzUyMnww&ixlib=rb-4.1.0&q=85",
    alt: "Australian electrician working on a residential switchboard",
    heroHeading: "A better growth system for electrical businesses.",
    heroCopy:
      "Help more local customers find your business, capture the right enquiries and keep follow-up moving while your team is on the tools.",
    challenges: [
      "Emergency call-outs and planned work compete for the same limited time.",
      "Missed calls during jobs mean ready customers ring the next electrician.",
      "Your Google presence does not reflect the quality of your work.",
      "Quotes go out but follow-up is inconsistent.",
    ],
    jobTypes: [
      "Emergency electrical repairs",
      "Switchboard upgrades and safety work",
      "Residential rewires and renovations",
      "Commercial fit-outs and maintenance",
      "Lighting, power points and smart-home",
    ],
    howCustomersChoose:
      "Electrical customers often search locally in a hurry, compare reviews and call the first credible business that answers. Fast response and visible trust signals decide who wins the job.",
    recommendedSystem:
      "Strengthen local visibility and reviews, run targeted campaigns for high-value services, and add missed-call text-back plus structured quote follow-up so opportunities are not lost while your team is on site.",
    planGuidance: "get-leads",
  },
  {
    slug: "plumbers",
    name: "Plumbers",
    image:
      "https://images.unsplash.com/photo-1641199788912-9a7385a35c82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxwbHVtYmVyJTIwdmFufGVufDB8fHx8MTc4NTgyMzUwOXww&ixlib=rb-4.1.0&q=85",
    alt: "Plumber's work van parked on a suburban street",
    heroHeading: "Keep the phone ringing for the work you want to win.",
    heroCopy:
      "Build a stronger local presence and a more reliable enquiry system around your plumbing business.",
    challenges: [
      "Urgent jobs arrive at unpredictable times and pull you off other work.",
      "Most enquiries come by phone while you are already on a job.",
      "Marketing has been tried without clear tracking or follow-up.",
      "Reviews are collected inconsistently.",
    ],
    jobTypes: [
      "Blocked drains and emergency repairs",
      "Hot water system replacement",
      "Bathroom and kitchen renovations",
      "Gas fitting and compliance",
      "Scheduled maintenance and inspections",
    ],
    howCustomersChoose:
      "Plumbing customers usually search on a mobile, need a fast answer and choose a business that looks trustworthy and responds quickly. Converting the call matters as much as being found.",
    recommendedSystem:
      "Improve local visibility and reviews, run service-specific campaigns across the right channels, and add missed-call handling and structured follow-up so more calls become booked jobs.",
    planGuidance: "get-leads",
  },
  {
    slug: "solar-battery-installers",
    name: "Solar and Battery Installers",
    image:
      "https://images.unsplash.com/photo-1758876734777-dcc6981f3671?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBwaG9uZXxlbnwwfHx8fDE3ODU4MjM1MDl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Installer reviewing enquiries on a phone on site",
    heroHeading: "Turn local energy interest into qualified sales opportunities.",
    heroCopy:
      "Connect visibility, campaigns, lead capture and follow-up across the solar and battery customer journey.",
    challenges: [
      "Longer sales cycles mean enquiries need consistent nurturing.",
      "High-intent leads are expensive and easy to waste with slow follow-up.",
      "Existing customers are an under-used source of battery and upgrade sales.",
      "Trust and credibility strongly influence who wins the quote.",
    ],
    jobTypes: [
      "Residential solar installation",
      "Battery storage and upgrades",
      "Energy assessments and consultations",
      "System servicing and monitoring",
      "Commercial energy projects",
    ],
    howCustomersChoose:
      "Solar and battery customers research carefully, compare quotes and value clear information and credibility. Structured follow-up over a longer cycle often decides the sale.",
    recommendedSystem:
      "Build local trust and visibility, run campaigns matched to intent, capture leads into a pipeline and follow up consultations and quotes consistently—including compliant reactivation of past enquiries.",
    planGuidance: "cruise-control",
  },
  {
    slug: "heating-cooling",
    name: "Heating and Cooling",
    image:
      "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxodmFjJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3ODU4MjM1MjJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Heating and cooling technician servicing an air-conditioning unit",
    heroHeading: "Meet seasonal demand without losing the enquiries.",
    heroCopy:
      "Build a growth system that captures peak-season interest and keeps maintenance customers coming back.",
    challenges: [
      "Demand spikes in summer and winter and can overwhelm follow-up.",
      "Replacement and repair enquiries need different responses.",
      "Maintenance opportunities are easy to forget.",
      "Fast response during peaks is difficult when the team is stretched.",
    ],
    jobTypes: [
      "Air-conditioning installation",
      "Heating system replacement",
      "Repairs and breakdowns",
      "Scheduled servicing and maintenance",
      "Ducted and split-system upgrades",
    ],
    howCustomersChoose:
      "Heating and cooling customers often act on comfort and urgency, especially in peak seasons. Being visible and responding quickly during demand spikes wins the work.",
    recommendedSystem:
      "Strengthen local visibility, run seasonally-timed campaigns, capture leads into a pipeline and use fast response plus maintenance reminders to convert and retain more customers.",
    planGuidance: "get-leads",
  },
  {
    slug: "builders-renovators",
    name: "Builders and Renovators",
    image:
      "https://images.unsplash.com/photo-1758876734777-dcc6981f3671?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBwaG9uZXxlbnwwfHx8fDE3ODU4MjM1MDl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Builder reviewing plans and enquiries on site",
    heroHeading: "Win higher-value projects with a credible presence and consistent follow-up.",
    heroCopy:
      "Connect portfolio credibility, qualified enquiries and structured quote follow-up across a longer sales cycle.",
    challenges: [
      "Higher-value enquiries need careful qualification.",
      "Portfolio credibility strongly influences the decision.",
      "Quote follow-up runs over weeks and is easy to let slip.",
      "The right project fit matters more than lead volume.",
    ],
    jobTypes: [
      "Home renovations and extensions",
      "New residential builds",
      "Bathroom and kitchen projects",
      "Structural and compliance work",
      "Design-and-construct projects",
    ],
    howCustomersChoose:
      "Building customers assess credibility, past work and trust before committing to a significant investment. A strong presence and disciplined follow-up separate the shortlist.",
    recommendedSystem:
      "Present your work credibly, attract better-fit enquiries, qualify leads carefully and follow up consultations and quotes consistently over the full decision cycle.",
    planGuidance: "cruise-control",
  },
  {
    slug: "landscapers",
    name: "Landscapers",
    image:
      "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxodmFjJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3ODU4MjM1MjJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Landscaper discussing a project on site",
    heroHeading: "Show the quality of your work and win better-fit projects.",
    heroCopy:
      "Build visual credibility, reach the right local customers and follow up quotes consistently through the season.",
    challenges: [
      "Visual credibility is essential and often under-presented online.",
      "Demand is seasonal and needs timing.",
      "Project fit varies widely and needs qualification.",
      "Quotes are often forgotten without structured follow-up.",
    ],
    jobTypes: [
      "Garden design and construction",
      "Paving, decking and retaining walls",
      "Lawn and turf projects",
      "Irrigation and drainage",
      "Maintenance packages",
    ],
    howCustomersChoose:
      "Landscaping customers respond strongly to before-and-after imagery and local reputation. Showing your work and following up quotes drives more booked projects.",
    recommendedSystem:
      "Build a visually credible presence, run seasonally-timed local campaigns, qualify project fit and follow up quotes consistently to convert more of the right work.",
    planGuidance: "get-leads",
  },
];

export const getIndustry = (slug) => industries.find((i) => i.slug === slug);
